import gql from 'graphql-tag';

export const GET_LC_STUDENTS = gql`
  query getStudents($user_id: Int!, $date: date) {
    students: v_students(
      where: {
        lc_id: { _eq: $user_id }
        _or: [
          { is_trial: { _is_null: true } }
          { is_trial: { _eq: false } }
          { trial_end_date: { _gte: $date } }
        ]
      }
    ) {
      user_id
      user_email
      user_first_name
      user_last_name
      user_preferred_name
      name  
      hc_name
      is_trial
      trial_end_date
      hc_id
      user_cognito_sub
      user_pic
      product_type
      has_active_subscription
      graduation_year
      student_profile {
        highschool_info
      }
      exercises_summary {
        done
        inprogress
        total
      }
      colleges(
        where: {
          app_deadline: { _neq: null, _gt: "now()" }
          _or: [
            { status: { _is_null: true } }
            { status: { _eq: "inprogress" } }
          ]
        }
        order_by: { app_deadline: asc }
        limit: 1
      ) {
        college_name
        app_deadline
      }
      app_submitted: colleges_aggregate(
        where: {
          _and: [
            { status: { _is_null: false } }
            { status: { _neq: "inprogress" } }
          ]
        }
      ) {
        aggregate {
          count
        }
      }
      colleges_aggregate(where: { category: { _neq: "student" } }) {
        aggregate {
          count
        }
      }
      documents_aggregate(
        where: {
          _or: [
            {
              university_id: { _neq: null }
              status: { _eq: "done" }
              university: { deleted: { _eq: false } }
            }
            {
              personal_statements_documents: {
                personal_statement: { status: { _eq: "done" } }
              }
            }
          ]
        }
      ) {
        aggregate {
          count
        }
      }
      milestones(where: { status: { _eq: "inprogress" } }, limit: 1) {
        name
      }
      group_student {
        group_id
        group {
          id
          name
        }
      }
      subscriptions(where: { end_date : { _gte : $date }  }) {
        end_date
      }
    }
  }
`;

export const GET_STUDENT = gql`
  query student($user_id: Int!) {
    users: v_students(where: { user_id: { _eq: $user_id } }) {
      user_email
      user_phone
      user_first_name
      user_id
      user_last_name
      user_cognito_sub
      user_pic
      is_trial
      gender_pronounce
      timezone
      gender
      state
      lc_id
      lc_sub
      hc_id
      hc_sub
      lc_email
      hc_email
      fa_id
      product_type
      stripe_customer_id
      product_plan_id
      group: group_student {
        group_id
      }
      chat_rooms {
        room_name
        id
      }
      hc_user: hc {
        user_first_name
        user_last_name
        user_pic
      }
      lc_user: lc {
        user_first_name
        user_last_name
        user_pic
      }
      admin {
        user_id
        user_first_name
        user_last_name
        user_pic
      }
      guardians {
          guardian {
              user_id
              user_first_name
              user_last_name
          }
      }  
    }
  }
`;
